/** Shift timeline axis: 11:00 → 03:00 Baghdad (16 h), positions in % of that span. */
export const HOUR = 3_600_000;
export const AXIS_HOURS = 16;

/** Position of an instant on a row's axis in % (11:00 Baghdad = 08:00Z of the row's day). */
export const axisPct = (day: string, t: number) =>
  Math.min(100, Math.max(0, ((t - Date.parse(`${day}T08:00:00Z`)) / (AXIS_HOURS * HOUR)) * 100));
